import { Component, Vue } from "vue-property-decorator";

@Component
export default class SessionMixins extends Vue {
  public isCancellable(state: string): boolean {
    switch (state) {
      case "canceled":
      case "completed":
        return false;
      default:
        return true;
    }
  }

  public isReviewable(state: string): boolean {
    switch (state) {
      case "canceled":
      case "active":
      case "finished":
      case "completed":
        return false;
      default:
        return true;
    }
  }
}
